import React from 'react'
import { supabase } from '../../../supabase';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const Logout = ({ children, classNames = "c-pointer" }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleLogout = async () => {
        await supabase.auth.signOut();
        dispatch({
            type: 'RESET_USER'
        })
        dispatch({
            type: 'RESET_SESSION'
        })
        localStorage.removeItem("email")
        localStorage.removeItem("pdp")
        navigate("/login");
    };
    
    return (
        <div className={`${classNames}`} onClick={() => handleLogout()}>{children}</div>
    )
}

export default Logout